<template>
  <div class="call-to-action">
    <h1 class="headline">
      Scopri come il tuo Brand è posizionato rispetto ai tuoi concorrenti con
      <span class="brand-name">
        <span class="brand">Brand</span><span class="ratio">Ratio</span>
      </span>
    </h1>
    <p class="subheadline">
      Capirai come migliorare la comunicazione del tuo brand e creare una importante community!
    </p>
  </div>
</template>

<script>
export default {
  name: 'CallToAction'
};
</script>

<style lang="scss" scoped>
.call-to-action {
  max-width: 1920px;
  text-align: center;
}

.headline {
  font-size: clamp(2.75rem, 5vw, 3.5rem);
  font-weight: 900;
  line-height: 1.2;
  color: #000000;
  margin-bottom: 1rem;
}

.brand-name {
  color: #2e4eed;
  display: inline-block;

  .brand {
    font-weight: 700;
  }

  .ratio {
    font-weight: 400;
  }
}

.subheadline {
  font-size: clamp(1.25rem, 2vw, 1.5rem);
  line-height: 1.6;
  font-weight: 600;
  color: #333;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .call-to-action {
    text-align: center;
  }
}
</style>